module.exports = __webpack_public_path__ + "static/img/8.34b6ebb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/fgimg/8.jpg
// module id = Y8Ga
// module chunks = 18